/**
 * Helper de traduction compact utilisé dans tous les data files.
 * Permet d'écrire les contenus multilingues de manière lisible :
 * p("Bonjour", "Hello", "Olá")
 */
export const p = (fr, en, pt) => ({ fr, en, pt });
